import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

const opts = {
    // theme: { dark: true },
};

Vue.use(Vuetify);

export default new Vuetify(opts);
